"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pick = void 0;
var tslib_1 = require("tslib");
// eslint-disable-next-line @typescript-eslint/ban-types
function pick(obj, keys) {
    return Object.assign.apply(Object, tslib_1.__spread([{}], Object.entries(obj)
        .filter(function (_a) {
        var _b = tslib_1.__read(_a, 1), key = _b[0];
        return keys.includes(key);
    })
        .map(function (_a) {
        var _b;
        var _c = tslib_1.__read(_a, 2), key = _c[0], value = _c[1];
        return (_b = {}, _b[key] = value, _b);
    })));
}
exports.pick = pick;
//# sourceMappingURL=pick.js.map